'use client';
import './DropZone.css';
import { useState } from 'react';
import SlIcon from '@shoelace-style/shoelace/dist/react/icon/index.js';

interface DropZoneProps {
	multiple: boolean;
	isCompact?: boolean;
	isCircle?: boolean;
	onDropFile: (e: any) => void | Promise<void>;
	onClick: () => void;
	t?: any;
}

const DropZone = ({
	multiple,
	isCompact = false,
	isCircle = false,
	onClick,
	onDropFile,
	t,
}: DropZoneProps) => {
	const [isDragActive, setIsDragActive] = useState<boolean>(false);

	const onDragEnter = (e: any) => {
		e.preventDefault();
		e.stopPropagation();
		setIsDragActive(true);
	};

	const onDragLeave = (e: any) => {
		e.preventDefault();
		e.stopPropagation();
		setIsDragActive(false);
	};

	const onDragOver = (e: any) => {
		e.preventDefault();
		e.stopPropagation();
		e.dataTransfer.dropEffect = 'copy';
		setIsDragActive(true);
	};

	const onDrop = async (e: any) => {
		e.preventDefault();
		e.stopPropagation();
		setIsDragActive(false);
		await onDropFile(e);
	};

	return (
		<div
			className={`drop-zone${isDragActive ? ' drop-zone--active' : ''}${
				isCircle ? ' drop-zone--circle' : ''
			}${isCompact ? ' drop-zone--compact' : ''}`}
			onDragEnter={onDragEnter}
			onDragLeave={onDragLeave}
			onDragOver={onDragOver}
			onDrop={onDrop}
			onClick={onClick}
		>
			<SlIcon className='drop-zone__icon' name={multiple ? 'images' : 'image'} />
			{isCompact || isCircle ? (
				<span>{t == null ? 'Aggiungi' : t('Add')}</span>
			) : multiple ? (
				t == null ? (
					'Trascina una o più immagini o clicca per aprire il file explorer'
				) : (
					t('Drag one or more images or click to open the file explorer')
				)
			) : t == null ? (
				`Trascina un'immage o clicca per aprire il file explorer`
			) : (
				t('Drag an image or click to open the file explorer')
			)}
		</div>
	);
};

export { DropZone };
